<template>
  <div>

    <modern-filter-bar
      embedded
      single-line
      :show-timeseries="!isToday"
      :period-options="appointmentPeriodOptions"
      :btn-active="btnActive"
      :search-text.sync="filter.patient_name"
      :show-search="!hasPatient"
      :show-period="onShowPeriod"
      :start-date.sync="filter.start_date"
      :end-date.sync="filter.end_date"
      search-placeholder="Cari nama pasien"
      @timeseries-click="btnActiveOnClick"
      @period-click="btnPeriodeOnClick"
      @search-keyup="filterByPatient"
      @period-search="filterByPeriode"
      @period-reset="resetFilterPeriode"
    >
      <template #before-search>
        <div
          v-if="!hasDoctor && !isMyAppointment && currentUser.user_type_id != 1"
          class="modern-filter-select"
        >
          <treeselect
            v-model="filter.doctor_id"
            :multiple="false"
            :options="doctors"
            :clearable="true"
            placeholder="Semua dokter"
            @input="filterByDoctor"
          />
        </div>
      </template>
      <template #additional-filters>
        <div v-if="showCoverageFilter" class="appointment-coverage-filter" role="group" aria-label="Jenis pasien">
          <button
            v-for="option in coverageOptions"
            :key="option.value"
            type="button"
            class="appointment-coverage-filter__option"
            :class="{ active: filter.coverage_type === option.value }"
            :aria-pressed="filter.coverage_type === option.value ? 'true' : 'false'"
            @click="filterByCoverage(option.value)"
          >
            <i :class="option.icon" aria-hidden="true"></i>
            <span>{{ option.label }}</span>
          </button>
        </div>
      </template>
      <template #right-period>
        <button type="button" class="btn-modern-export" @click="btnExportOnClick">
          <i class="fas fa-file-excel" aria-hidden="true"></i>
          <span>Ekspor</span>
        </button>
      </template>
    </modern-filter-bar>

    <!-- Filter status kunjungan -->
    <section class="appointment-status-filter" aria-label="Filter status kunjungan">
      <div class="appointment-status-filter__heading">
        <span class="appointment-status-filter__icon" aria-hidden="true">
          <i class="fas fa-filter"></i>
        </span>
        <div>
          <strong>Status kunjungan</strong>
          <small>Pilih tahapan pelayanan pasien</small>
        </div>
      </div>
      <div class="appointment-status-filter__track" role="tablist" aria-label="Status perjanjian">
        <button
          type="button"
          role="tab"
          class="appointment-status-filter__button"
          :class="{ active: isAppointmentStatusActive('') }"
          :aria-selected="isAppointmentStatusActive('') ? 'true' : 'false'"
          @click="resetAppointmentStatus"
        >
          <span class="appointment-status-filter__dot appointment-status-filter__dot--all" aria-hidden="true"></span>
          <span>Semua</span>
        </button>
        <button
          v-for="status in appointmentStatuses"
          :key="status.id"
          type="button"
          role="tab"
          class="appointment-status-filter__button"
          :class="{ active: isAppointmentStatusActive(status.id) }"
          :aria-selected="isAppointmentStatusActive(status.id) ? 'true' : 'false'"
          @click="navStatusOnClick(status.id)"
        >
          <span
            class="appointment-status-filter__dot"
            :class="statusDotClass(status.name)"
            aria-hidden="true"
          ></span>
          <span>{{ status.name }}</span>
        </button>
      </div>
    </section>

    <!-- Table -->
    <medhop-data-table
      summary-title="Daftar Perjanjian"
      :busy="loading"
      striped
      hover
      responsive
      class="appointment-data-table"
      :items="items"
      :fields="fields">
      <template #table-busy>
        <div class="appointment-loading" role="status" aria-live="polite">
          <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <span>Memuat 15 data untuk halaman ini...</span>
        </div>
      </template>
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{
            width:
              hasDoctor || hasPatient
                ? field.key === 'actions'
                  ? '15%'
                  : ''
                : field.key === 'actions'
                  ? '25%'
                  : '',
          }" />
      </template>
      <template #cell(doctor_name_action_type_name)="data">
        <span class="d-block">{{ data.item.doctor_name }}</span>
        <span class="d-block">{{ data.item.action_type_name }}</span>
      </template>
      <template #cell(display_date)="data">
        {{
          new Date(data.item.date)
            .toLocaleString("id-ID", {
              weekday: "long",
              day: "numeric",
              month: "2-digit",
              year: "numeric",
            })
            .replaceAll("/", "-")
        }}
      </template>
      <template #cell(appointment_status_name)="data">
        <b-badge
          pill
          @click="btnStatusOnclick(data.item)"
          v-b-modal.modal-status
          :class="`${data.item.appointment_status_color}`">{{ data.item.appointment_status_name }}</b-badge>
      </template>
      <template #cell(actions)="data">
        <div class="d-flex">
          <b-button
            size="sm"
            class="mr-1"
            variant="primary"
            v-b-tooltip.hover
            title="Cetak Stiker Obat"
            @click="btnPrintStickerOnClick(data.item)"><i class="fas fa-print px-0"></i></b-button>
          <b-button
            size="sm"
            class="mr-1 btn-info"
            v-b-tooltip.hover
            title="Detail"
            @click="
              $router.push({ path: '/appointment/detail/' + data.item.id })
              "><i class="fas fa-eye px-0"></i></b-button>
          <template v-if="!hasPatient">
            <template v-if="!isMyAppointment">
              <b-button
                size="sm"
                class="mr-1 btn-success"
                v-b-tooltip.hover
                title="Edit"
                v-if="manipulateBtn == true"
                @click="
                  $router.push({ path: '/appointment/edit/' + data.item.id })
                  "><i class="fas fa-edit px-0"></i></b-button>
              <b-button
                size="sm"
                class="btn-danger mr-1"
                v-b-tooltip.hover
                title="Hapus"
                v-if="manipulateBtn == true"
                @click="btnDeleteOnClick(data.item.id)"><i class="fas fa-trash px-0"></i></b-button>
            </template>
          </template>
          <template v-if="data.item.appointment_status_id == 4">
            <b-button
              v-if="caseManagerShortcut"
              size="sm"
              class="mr-1 btn-success"
              v-b-tooltip.hover
              title="Tambah Rekam Medis"
              @click="
                $router.push(
                  `/patient/cases?doctor_id=${data.item.doctor_id}&patient_id=${data.item.patient_id}&patient_name=${data.item.patient_name}&appointment_id=${data.item.id}`
                )
                "><i class="fas fa-user-md px-0"></i></b-button>
            <b-button
              v-if="paymentShortcut"
              size="sm"
              class="mr-1 btn-primary"
              variant="primary"
              v-b-tooltip.hover
              title="Tambah Invoice"
              @click="
                $router.push(
                  `/payment/add?doctor_id=${data.item.doctor_id}&patient_id=${data.item.patient_id}&patient_name=${data.item.patient_name}&appointment_id=${data.item.id}`
                )
                "><i class="fas fa-money-bill-wave px-0"></i></b-button>
            <b-button
              v-if="prescriptionShortcut"
              size="sm"
              class="mr-1 btn-info"
              v-b-tooltip.hover
              title="Tambah Resep"
              @click="
                $router.push(
                  `/prescriptions/add?doctor_id=${data.item.doctor_id}&doctor_name=${data.item.doctor_name}&patient_id=${data.item.patient_id}&patient_name=${data.item.patient_name}&appointment_id=${data.item.id}`
                )
                "><i class="fas fa-receipt px-0"></i></b-button>
            <b-button
              v-if="medicalActionShortcut"
              size="sm"
              class="btn-success"
              v-b-tooltip.hover
              title="Tambah Tindakan Medis"
              @click="
                $router.push(
                  `/medical-actions/add?doctor_id=${data.item.doctor_id}&doctor_name=${data.item.doctor_name}&patient_id=${data.item.patient_id}&patient_name=${data.item.patient_name}&appointment_id=${data.item.id}`
                )
                "><i class="fas fa-diagnoses px-0"></i></b-button>
          </template>
        </div>
      </template>
    </medhop-data-table>
    <data-table-pagination
      v-if="items.length != 0"
      :page="currentPage"
      :total-rows="totalRows"
      :per-page="perPage || 15"
      @change="pageOnClick" />

    <!-- modal status -->
    <b-modal
      id="modal-status"
      title="Ubah Status Perjanjian"
      size="lg"
      @ok="modalStatusOnSubmit"
      @hidden="modalStatusOnHide">
      <b-form-group
        label="Pilih Status Perjanjian"
        v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="radio-group-status"
          v-model="item.appointment_status_id"
          :options="radioAppointmentStatus"
          :aria-describedby="ariaDescribedby"
          name="appointment-status-id"></b-form-radio-group>
      </b-form-group>
    </b-modal>

    <!-- modal export -->
    <b-modal
      id="modal-excel"
      size="xl"
      title="Expor Daftar Perjanjian"
      style="max-width: 30px overflow: scroll"
      hide-footer>
      <div class="d-flex justify-content-start align-items-center mt-5">
        <button
          class="btn btn-warning mr-1"
          v-b-tooltip.hover
          title="Download Excel"
          @click="btnExcelOnClick">
          <i class="fas px-0 fa-file-excel"></i>
        </button>
      </div>
      <medhop-data-table
        summary-title="Pratinjau Ekspor Perjanjian"
        striped
        hover
        responsive
        class="mt-3"
        :items="itemPopUp"
        :fields="fieldPopUp">
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{
              width:
                hasDoctor || hasPatient
                  ? field.key === 'actions'
                    ? '15%'
                    : ''
                  : field.key === 'actions'
                    ? '25%'
                    : '',
            }" />
        </template>
        <template #cell(doctor_name_action_type_name)="data">
          <span class="d-block">{{ data.item.doctor_name }}</span>
          <span class="d-block">{{ data.item.action_type_name }}</span>
        </template>
        <template #cell(display_date)="data">
          {{
            new Date(data.item.date).toLocaleString("id-ID", {
              weekday: "long",
              day: "numeric",
              month: "numeric",
              year: "numeric",
            })
          }}
        </template>
        <template #cell(appointment_status_name)="data">
          <div class="text-center">
            {{ data.item.appointment_status_name }}
          </div>
        </template>
      </medhop-data-table>
    </b-modal>

    <!-- print layout -->
    <ModalFormSticker :data="print" :count="printCount" />

  </div>
</template>

<script>

import XLSX from "xlsx"
import ModalFormSticker from "@/component/appointments/ModalFormStickerPrint.vue"
import DataTablePagination from "@/component/common/DataTablePagination.vue"
import Treeselect from "@riophae/vue-treeselect"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"
import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js"
import AppointmentModule from "@/core/modules/AppointmentModule"
import DoctorModule from "@/core/modules/DoctorModule"
import { getUser } from "@/core/services/jwt.service.js"
import moment from "moment"

export default {

  props: {
    isToday: Boolean,
    isUpcoming: Boolean,
    hasDoctor: Boolean,
    hasPatient: Boolean,
    isMyAppointment: Boolean,
    fields: Array,
    items: Array,
    itemExcel: Array,
    itemPopUp: Array,
    perPage: { type: Number, default: 15 },
    currentPage: Number,
    totalRows: Number,
    tabFiled: Number,
    loading: Boolean,
    showCoverageFilter: Boolean,
    initialFilter: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    DataTablePagination,
    ModalFormSticker,
    Treeselect,
    XLSX,
  },

  data() {
    return {
      filter: {
        appointment_status_id: "",
        doctor_id: null,
        patient_name: "",
        coverage_type: "",
        start_date: "",
        end_date: "",
        ...this.initialFilter,
        doctor_id:
          this.initialFilter.doctor_id === "" ||
          typeof this.initialFilter.doctor_id === "undefined"
            ? null
            : this.initialFilter.doctor_id,
      },
      onShowPeriod: false,
      btnActive: {
        days: this.isToday,
        month: !this.isToday,
        lastMonth: false,
        year: false,
        period: false,
      },
      fieldPopUp: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "display_date",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "time",
          label: "Waktu",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Pasien",
          sortable: true,
        },
        {
          key: "doctor_name_action_type_name",
          label: "Dokter & Jenis Tindakan",
          sortable: true,
        },
        {
          key: "appointment_status_name",
          label: "Status",
          sortable: true,
        },
      ],
      appointmentStatuses: [],
      coverageOptions: [
        { value: "", label: "Semua", icon: "fas fa-users" },
        { value: "bpjs", label: "BPJS", icon: "fas fa-shield-alt" },
        { value: "non_bpjs", label: "Non-BPJS", icon: "fas fa-wallet" },
      ],
      doctors: [],
      radioAppointmentStatus: [],
      item: {},
      tabActive: false,
      tabNumber: 5,
      print: {
        patient_number: "",
        patient_name: "",
        patient_gender: "",
        patient_birth_date: "",
        appointment_date: "",
      },
      printCount: 2,
      manipulateBtn: false,
      statusAppointment: false,
      caseManagerShortcut: false,
      paymentShortcut: false,
      prescriptionShortcut: false,
      medicalActionShortcut: false,
      currentUser: getUser(),
      setting: {},
    }
  },

  computed: {
    appointmentPeriodOptions() {
      const periods = [
        { value: "days", label: "Hari Ini" },
        { value: "month", label: "Bulan Ini" },
        { value: "lastMonth", label: "Bulan Kemarin" },
        { value: "year", label: "Tahun Ini" },
        { value: "period", label: "Periode" },
      ]

      return this.isUpcoming
        ? periods.filter((period) => period.value !== "days")
        : periods
    },
  },

  methods: {

    btnPrintStickerOnClick(item) {
      this.$bvModal.show("modal-form-sticker-print")
      this.print.patient_number = item.patient_number
      this.print.patient_name = item.display_patient_name
      this.print.patient_gender = item.patient_gender
      this.print.patient_birth_date = item.patient_birth_date
      this.print.appointment_date = item.date
    },

    async getSetting() {
      this.setting = await module.get(`settings/${1}`)
    },

    btnExportOnClick() {
      this.$bvModal.show('modal-excel')
      this.$emit('btnExportOnClick', this.normalizedFilter())
    },

    btnExcelOnClick() {
      const data = XLSX.utils.json_to_sheet(this.itemExcel)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data, "data")
      XLSX.writeFile(wb, `Daftar Perjanjian ${this.setting.clinic_name}.xlsx`)
    },

    async getAppointmentStatuses() {
      const data = await AppointmentModule.getSimpleAppointmentStatuses()
      this.appointmentStatuses = data
      data.forEach((value) => {
        this.radioAppointmentStatus.push({ text: value.name, value: value.id })
      })
    },

    async getDoctorsOption() {
      const data = await DoctorModule.getTreeSelect()
      this.doctors = (Array.isArray(data) ? data : []).filter((doctor) => {
        const label = doctor && String(doctor.label || "").trim()
        return doctor && doctor.id !== "" && label && label.toLowerCase() !== "(unknown)"
      })

      if (
        this.filter.doctor_id != null &&
        !this.doctors.some(
          (doctor) => String(doctor.id) === String(this.filter.doctor_id)
        )
      ) {
        this.filter.doctor_id = null
      }
    },

    pageOnClick(page) {
      this.$emit("pageOnClick", page)
    },

    resetFilterPeriode(sent = {}) {
      this.filter = {
        ...this.filter,
        ...sent,
        start_date: "",
        end_date: "",
      }
      if (this.currentUser.user_type_id == 1) {
        this.filter.doctor_id = this.currentUser.user_id
      }
      this.$emit("filter", this.normalizedFilter())
    },

    forwardFilter(filter) {
      this.filter = {
        ...filter,
        doctor_id: filter.doctor_id == null ? null : filter.doctor_id,
      }
      this.$emit("filter", this.normalizedFilter())
    },

    normalizedFilter() {
      return {
        ...this.filter,
        doctor_id: this.filter.doctor_id == null ? "" : this.filter.doctor_id,
      }
    },

    filterByPeriode() {
      this.$emit("filter", this.normalizedFilter())
    },

    filterByPatient() {
      debouncer(() => {
        this.$emit("filterByPatient", this.normalizedFilter())
      }, 500)
    },

    filterByCoverage(coverageType) {
      if (this.filter.coverage_type === coverageType) return
      this.filter.coverage_type = coverageType
      this.$emit("filter", this.normalizedFilter())
    },

    resetAppointmentStatus() {
      this.filter.appointment_status_id = ""
      this.$emit("filter", this.normalizedFilter())
    },

    isAppointmentStatusActive(statusId) {
      const currentStatus = this.filter.appointment_status_id
      if (statusId === "") return currentStatus === "" || currentStatus == null
      return String(currentStatus) === String(statusId)
    },

    statusDotClass(statusName) {
      const name = String(statusName || "").toLowerCase()
      if (name.includes("diajukan")) return "appointment-status-filter__dot--submitted"
      if (name.includes("menunggu")) return "appointment-status-filter__dot--waiting"
      if (name.includes("terkonfirmasi")) return "appointment-status-filter__dot--confirmed"
      if (name.includes("ditangani")) return "appointment-status-filter__dot--handled"
      if (name.includes("batal")) return "appointment-status-filter__dot--cancelled"
      if (name.includes("selesai") || name.includes("pulang")) return "appointment-status-filter__dot--completed"
      return "appointment-status-filter__dot--default"
    },

    async filterByDoctor(evt) {
      await this.filter.doctor_id
      this.$emit("filter", this.normalizedFilter())
    },

    navStatusOnClick(appointmentStatusId) {
      this.filter.appointment_status_id = appointmentStatusId
      this.$emit("filter", this.normalizedFilter())
    },

    btnStatusOnclick(item) {
      for (const [key, value] of Object.entries(item)) {
        this.item[key] = value
      }
    },

    async modalStatusOnSubmit(evt) {
      this.item["_method"] = "put"
      let response = await module.submit(
        this.item,
        `appointments/change-status/${this.item.id}`
      )
      if (response.state == "error") {
        Swal.fire("Gagal", "Terjadi Kesalahan", "error")
        return
      }
      this.$root.$emit("UpdateNewAppointment")
      this.$emit("appointmentOnStatusChange")
      Swal.fire(response.success.title, response.success.message, "success")
    },

    modalStatusOnHide() {
      this.item = {}
    },

    btnDeleteOnClick(id) {
      this.$emit("btnDeleteOnClick", id)
    },

    // Global emit
    globalEmit() {
      this.$root.$emit("filterAppointment", this.normalizedFilter())
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      )
      let access_right = JSON.parse(access_right_user)
      for (let a = 0; a < access_right.length; a++) {
        if (access_right[a] == "5002") this.manipulateBtn = true
        if (access_right[a] == "5003") this.statusAppointment = true
        if (access_right[a] == "3006") this.caseManagerShortcut = true
        if (access_right[a] == "6002") this.paymentShortcut = true
        if (access_right[a] == "8002") this.prescriptionShortcut = true
        if (access_right[a] == "1202") this.medicalActionShortcut = true
      }
    },

    btnPeriodeOnClick() {
      if (this.onShowPeriod == false) {
        this.onShowPeriod = true
        this.btnActiveOnClick("period")
      } else {
        this.onShowPeriod = false
        this.btnActiveOnClick("period")
      }
    },

    btnActiveOnClick(type) {
      if (type == "days") {
        // set time
        this.filter.start_date = moment()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
        this.filter.end_date = moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")

        // get data
        // this.pagination()
        this.$emit("filter", this.filter)

        // set btn Active
        this.btnActive.days = true
        this.btnActive.month = false
        this.btnActive.lastMonth = false
        this.btnActive.year = false
        this.btnActive.period = false

        // hide period
        this.onShowPeriod = false
      } else if (type == "month") {
        // set time
        this.filter.start_date = moment()
          .startOf("month")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
        this.filter.end_date = moment()
          .endOf("month")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")

        // get data
        // this.pagination()
        this.$emit("filter", this.filter)

        // set btn Active
        this.btnActive.days = false
        this.btnActive.month = true
        this.btnActive.lastMonth = false
        this.btnActive.year = false
        this.btnActive.period = false

        // hide period
        this.onShowPeriod = false
      } else if (type == "lastMonth") {
        // set time
        this.filter.start_date = moment()
          .subtract(1, "months")
          .startOf("month")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
        this.filter.end_date = moment()
          .subtract(1, "months")
          .endOf("month")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")

        // get data
        // this.pagination()
        this.$emit("filter", this.filter)

        // set btn Active
        this.btnActive.days = false
        this.btnActive.month = false
        this.btnActive.lastMonth = true
        this.btnActive.year = false
        this.btnActive.period = false

        // hide period
        this.onShowPeriod = false
      } else if (type == "year") {
        // set time
        this.filter.start_date = moment()
          .startOf("year")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
        this.filter.end_date = moment()
          .endOf("year")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")

        // get data
        // this.pagination()
        this.$emit("filter", this.filter)

        // set btn Active
        this.btnActive.days = false
        this.btnActive.month = false
        this.btnActive.lastMonth = false
        this.btnActive.year = true
        this.btnActive.period = false

        // hide period
        this.onShowPeriod = false
      } else if (type == "period") {
        // set time
        this.filter.start_date = ""
        this.filter.end_date = ""

        // set btn Active
        this.btnActive.days = false
        this.btnActive.month = false
        this.btnActive.lastMonth = false
        this.btnActive.year = false
        this.btnActive.period = true
      }
    }

  },

  watch: {
    "initialFilter.appointment_status_id": function (newVal) {
      this.filter.appointment_status_id = newVal == null ? "" : newVal
    },
    "filter.doctor_id": function (newVal, oldVal) {
      if (typeof newVal === "undefined") {
        this.filter.doctor_id = null
        this.filterByDoctor()
      }
    }
  },

  mounted() {
    this.$root.$on("appointment-submission", () => {
      this.tabActive = true
      this.filter.appointment_status_id = 5
      this.globalEmit()
    })
    this.setActiveMenu()
    this.getSetting()
    this.getAppointmentStatuses()
    if (this.currentUser.user_type_id != 1)
      this.getDoctorsOption()
    if (this.isUpcoming) {
      this.btnActive.days = false
      this.btnActive.month = true
    }
  }

}
</script>

<style lang="scss" scoped>
/* Kustomisasi Tab Navigasi modern (seperti Eena) */
.appointment-coverage-filter {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  min-height: 40px;
  padding: 3px;
  border: 1px solid #dbe4ec;
  border-radius: 11px;
  background: #f7f9fb;
}

.appointment-coverage-filter__option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 650;
  white-space: nowrap;
  transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease;
}

.appointment-coverage-filter__option i {
  color: #8a9aab !important;
  font-size: 12px;
}

.appointment-coverage-filter__option:hover {
  background: #edf6f7;
  color: #16867f;
}

.appointment-coverage-filter__option.active {
  background: #ffffff;
  color: #116e6a;
  box-shadow: 0 2px 8px rgba(20, 50, 99, 0.1);
}

.appointment-coverage-filter__option.active i {
  color: #16867f !important;
}

.appointment-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  min-height: 112px;
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 600;
}

.appointment-loading .spinner-border {
  color: #16867f;
}

.appointment-status-filter {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 14px;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 15px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 8px 24px rgba(20, 50, 99, 0.05);
}

.appointment-status-filter__heading {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  padding: 0 5px;
}

.appointment-status-filter__heading strong,
.appointment-status-filter__heading small {
  display: block;
  white-space: nowrap;
}

.appointment-status-filter__heading strong {
  color: #29465f;
  font-size: 12px;
  font-weight: 750;
}

.appointment-status-filter__heading small {
  margin-top: 1px;
  color: #94a3b8;
  font-size: 10.5px;
}

.appointment-status-filter__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #eaf7f6;
  color: #16867f;
}

.appointment-status-filter__icon i {
  color: #16867f !important;
  font-size: 12px;
}

.appointment-status-filter__track {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 4px;
  overflow-x: auto;
  border: 1px solid #e5ebf1;
  border-radius: 11px;
  background: #f1f5f9;
  scrollbar-width: thin;
}

.appointment-status-filter__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 11.5px;
  font-weight: 650;
  white-space: nowrap;
  outline: 0;
  transition: color 160ms ease, background 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.appointment-status-filter__button:hover {
  background: rgba(255, 255, 255, 0.78);
  color: #29465f;
}

.appointment-status-filter__button:focus-visible {
  box-shadow: 0 0 0 3px rgba(22, 134, 127, 0.16);
}

.appointment-status-filter__button.active {
  background: linear-gradient(135deg, #143263 0%, #14608f 58%, #16867f 100%);
  color: #ffffff;
  box-shadow: 0 5px 13px rgba(20, 96, 143, 0.22);
  transform: translateY(-1px);
}

.appointment-status-filter__dot {
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 50%;
  background: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.12);
}

.appointment-status-filter__dot--all { background: #64748b; }
.appointment-status-filter__dot--submitted { background: #4f7cff; }
.appointment-status-filter__dot--waiting { background: #f59e0b; }
.appointment-status-filter__dot--confirmed { background: #22a699; }
.appointment-status-filter__dot--handled { background: #38bdf8; }
.appointment-status-filter__dot--cancelled { background: #ef4444; }
.appointment-status-filter__dot--completed { background: #22c55e; }
.appointment-status-filter__dot--default { background: #94a3b8; }

.appointment-status-filter__button.active .appointment-status-filter__dot {
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.17);
}

.appointment-data-table {
  margin-top: 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .appointment-data-table table {
  margin-bottom: 0;
}

::v-deep .appointment-data-table thead th {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  border-top: 0;
  background: #f8fafc;
  color: #52677d;
  font-size: 11.5px;
  letter-spacing: 0.025em;
}

::v-deep .appointment-data-table tbody td {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  vertical-align: middle;
}


/* Kustomisasi filter button & ekspor bergaya modern soft-3D (Skeuomorphic pill) seperti referensi */
.btn-timeseries,
.btn.btn-timeseries {
  border-radius: 9999px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 0.5rem 1.25rem !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: none !important;
  margin: 4px 6px !important; /* Jarak yang seimbang agar pas dan tidak menumpuk ke bawah */
  display: inline-block !important;
  vertical-align: middle !important;
}

/* State Aktif (Menggunakan warna Navy #143263 gradasi ke Navy-mid #14608F) */
.btn-info,
.btn.btn-info.btn-timeseries {
  background: linear-gradient(135deg, #143263 0%, #14608F 100%) !important;
  border: none !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 10px rgba(20, 50, 99, 0.25), inset 0 1px 1px rgba(255, 255, 255, 0.2) !important;
}

/* State Inaktif (Menggunakan border tipis Teal #1E958F transparan dengan hover soft) */
.btn-outline-info,
.btn.btn-outline-info.btn-timeseries {
  background-color: transparent !important;
  color: #1E958F !important;
  border: 1px solid #1E958F !important;
  box-shadow: none !important;

  &:hover {
    background-color: rgba(30, 149, 143, 0.08) !important;
    color: #1E958F !important;
    border-color: #1E958F !important;
  }
}

/* Tombol Ekspor */
.btn-primary,
.btn.btn-primary {
  border-radius: 9999px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  padding: 0.5rem 1.5rem !important;
  border: none !important;
  background: linear-gradient(135deg, #1E958F 0%, #14608F 100%) !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(30, 149, 143, 0.25), inset 0 1px 1px rgba(255, 255, 255, 0.2) !important;
  transition: all 0.25s ease !important;
  transform: translateY(0);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(30, 149, 143, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.2) !important;
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 6px rgba(30, 149, 143, 0.2) !important;
  }
}

/* Unified appointment filter controls */
.appointment-table-toolbar {
  row-gap: 14px;
  margin-top: 0;
}

.appointment-filter-column {
  margin-top: 0 !important;
}

.appointment-control-label,
.appointment-period-field > label {
  display: block;
  margin: 0 0 7px;
  color: #536174;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.025em;
}

.appointment-filter-control,
.appointment-search-control,
.appointment-date-control {
  display: flex;
  align-items: center;
  height: 46px;
  min-height: 46px;
  background: #FFFFFF;
  border: 1px solid #DCE5EF;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(20, 50, 99, 0.035);
  transition: border-color 180ms ease, box-shadow 180ms ease, background 180ms ease;
}

.appointment-filter-control:focus-within,
.appointment-search-control:focus-within,
.appointment-date-control:focus-within {
  background: #FFFFFF;
  border-color: #1E958F;
  box-shadow: 0 0 0 3px rgba(30, 149, 143, 0.12);
}

.appointment-control-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  color: #1E958F;
}

.appointment-control-icon i,
.appointment-control-icon svg {
  color: #1E958F !important;
  font-size: 15px;
}

.appointment-doctor-select {
  min-width: 0;
  flex: 1;
}

::v-deep .appointment-doctor-select.vue-treeselect {
  height: 44px !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

::v-deep .appointment-doctor-select .vue-treeselect__control {
  height: 44px !important;
  min-height: 44px !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 11px 11px 0 !important;
  box-shadow: none !important;
}

::v-deep .appointment-doctor-select .vue-treeselect__value-container {
  height: 44px !important;
  padding: 0 6px 0 0 !important;
}

::v-deep .appointment-doctor-select .vue-treeselect__input-container {
  height: 44px !important;
  padding: 0 !important;
}

::v-deep .appointment-doctor-select input.vue-treeselect__input {
  width: 100% !important;
  height: 44px !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  color: #1A2433 !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  font: inherit !important;
  line-height: 44px !important;
}

::v-deep .appointment-doctor-select input.vue-treeselect__input:focus {
  border: 0 !important;
  box-shadow: none !important;
}

::v-deep .appointment-doctor-select .vue-treeselect__single-value,
::v-deep .appointment-doctor-select .vue-treeselect__placeholder {
  overflow: hidden;
  color: #6B7280 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  line-height: 44px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .appointment-doctor-select .vue-treeselect__control-arrow-container,
::v-deep .appointment-doctor-select .vue-treeselect__clear-container {
  width: 36px !important;
}

::v-deep .appointment-doctor-select .vue-treeselect__control-arrow {
  width: 8px;
  height: 8px;
  fill: #6B7280 !important;
}

::v-deep .appointment-doctor-select .vue-treeselect__menu {
  margin-top: 7px;
  border: 1px solid #E7EDF4 !important;
  border-radius: 14px !important;
  box-shadow: 0 18px 42px rgba(20, 50, 99, 0.16) !important;
}

.appointment-search-input.form-control,
.appointment-date-input.form-control {
  height: 44px !important;
  min-height: 0 !important;
  padding: 0 12px 0 0 !important;
  color: #1A2433 !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 11px 11px 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  font-size: 12px !important;
  font-weight: 600;
}

.appointment-search-input.form-control:focus,
.appointment-date-input.form-control:focus {
  border: 0 !important;
  box-shadow: none !important;
}

.appointment-search-input.form-control::placeholder,
.appointment-date-input.form-control::placeholder {
  color: #9AA6B6 !important;
}

.appointment-period-filter {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) auto minmax(180px, 1fr) auto;
  align-items: end;
  gap: 12px;
  padding: 16px;
  background: #F8FAFC;
  border: 1px solid #E7EDF4;
  border-radius: 16px;
  box-shadow: 0 7px 20px rgba(20, 50, 99, 0.045);
}

.appointment-period-field {
  min-width: 0;
}

.appointment-datepicker-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  color: #1E958F !important;
}

::v-deep .appointment-datepicker-button .btn {
  width: 44px !important;
  height: 44px !important;
  padding: 0 !important;
  color: #1E958F !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 11px 0 0 11px !important;
  box-shadow: none !important;
}

::v-deep .appointment-datepicker-button .btn:hover,
::v-deep .appointment-datepicker-button .btn:focus {
  color: #143263 !important;
  background: rgba(30, 149, 143, 0.08) !important;
  box-shadow: none !important;
}

.appointment-period-separator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 46px;
  color: #9AA6B6;
  font-size: 11px;
}

.appointment-period-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.appointment-period-button.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 46px !important;
  min-width: 106px;
  padding: 0 15px !important;
  border-radius: 12px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  box-shadow: none !important;
}

.appointment-period-button--apply.btn {
  color: #FFFFFF !important;
  background: linear-gradient(135deg, #143263, #14608F 55%, #1E958F) !important;
  border: 0 !important;
}

.appointment-period-button--apply.btn:hover {
  box-shadow: 0 8px 18px rgba(20, 96, 143, 0.22) !important;
}

.appointment-period-button--reset.btn {
  color: #536174 !important;
  background: #FFFFFF !important;
  border: 1px solid #DCE5EF !important;
}

.appointment-period-button--reset.btn:hover {
  color: #143263 !important;
  background: rgba(20, 50, 99, 0.06) !important;
  border-color: #C8D5E3 !important;
}

@media (max-width: 1199.98px) {
  .appointment-status-filter {
    align-items: flex-start;
    flex-direction: column;
    gap: 9px;
  }

  .appointment-status-filter__track {
    width: 100%;
  }

  .appointment-period-filter {
    grid-template-columns: minmax(180px, 1fr) auto minmax(180px, 1fr);
  }

  .appointment-period-actions {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
}

@media (max-width: 767.98px) {
  .appointment-status-filter {
    margin-top: 12px;
    padding: 9px;
    border-radius: 13px;
  }

  .appointment-status-filter__heading small {
    display: none;
  }

  .appointment-status-filter__button {
    min-height: 34px;
    padding: 0 10px;
  }

  .appointment-coverage-filter {
    width: 100%;
    overflow-x: auto;
  }

  .appointment-coverage-filter__option {
    flex: 1 0 auto;
  }

  .appointment-filter-column {
    margin-top: 0 !important;
  }

  .appointment-period-filter {
    grid-template-columns: 1fr;
    padding: 14px;
  }

  .appointment-period-separator {
    width: 100%;
    height: 18px;
    transform: rotate(90deg);
  }

  .appointment-period-actions {
    grid-column: auto;
  }

  .appointment-period-button.btn {
    flex: 1;
  }
}
</style>
